import { useEffect } from 'react';
import { instanceOf, string } from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { Error as ErrorIcon } from '@material-ui/icons';

import useStyles from './ErrorMessageStyles';

export default function ErrorMessage(props) {
    const { error, componentStack } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.error(error.message, error.stack);
    }, [error]);

    return (
        <div>
            <div className={classes.errorHeader}>
                <ErrorIcon style={{ color: theme.palette.error.dark }} />
                <span>{error?.message}</span>
            </div>
            <pre className={classes.errorStack}>{componentStack}</pre>
        </div>
    );
}

ErrorMessage.propTypes = {
    error: instanceOf(Error).isRequired,
    componentStack: string.isRequired,
};
